import { toDefaultMicDateFormat } from 'utils/common';
import { Button1 } from 'components/Button';

const resolveProjName = (projId, projNameById = {}) => {
  if (!projId) return '';
  return projNameById[String(projId).toLowerCase()] || projId;
};

const isUpdateLocalDataOn = (row) =>
  row?.UpdateLocalData === true || row?.UpdateLocalData === 1 || row?.UpdateLocalData === '1';

export const appDeviceVersionColumns = ({ t, projNameById, onUpdateLocalData }) => [
  {
    headerName: t('USERNAME'),
    field: 'Username',
    width: 140
  },
  {
    headerName: t('PROJECT'),
    field: 'ProjId',
    width: 280,
    valueGetter: ({ row }) => resolveProjName(row?.ProjId, projNameById),
    renderCell: ({ row }) => <span>{resolveProjName(row?.ProjId, projNameById)}</span>
  },
  {
    headerName: t('DEVICEID'),
    field: 'DeviceId',
    width: 120
  },
  {
    headerName: t('DEVICE_TYPE'),
    field: 'DeviceType',
    width: 120
  },
  {
    headerName: t('APP_VERSION'),
    field: 'AppVersionName',
    width: 130
  },
  {
    headerName: t('SOFT_TARGET_VERSION'),
    field: 'SoftTargetVersion',
    width: 140
  },
  {
    headerName: t('HARD_TARGET_VERSION'),
    field: 'HardTargetVersion',
    width: 140
  },
  {
    headerName: t('UPDATE_LOCAL_DATA'),
    field: 'UpdateLocalData',
    width: 140,
    valueGetter: ({ row }) => (isUpdateLocalDataOn(row) ? t('YES') : t('NO')),
    renderCell: ({ row }) => <span>{isUpdateLocalDataOn(row) ? t('YES') : t('NO')}</span>
  },
  {
    headerName: t('BUILD_ENVIRONMENT'),
    field: 'BuildEnvironment',
    width: 130
  },
  {
    headerName: t('UPDATED_DATE'),
    field: 'UpdatedDate',
    width: 170,
    renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.UpdatedDate)}</span>
  },
  {
    headerName: t('CREATED_DATE'),
    field: 'CreateDate',
    width: 170,
    renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.CreateDate)}</span>
  },
  {
    headerName: t('UPDATE_LOCAL_DATA'),
    field: 'actions',
    width: 180,
    sortable: false,
    filterable: false,
    renderCell: ({ row }) => {
      const pending = isUpdateLocalDataOn(row);
      return (
        <Button1
          text={pending ? t('CLEAR_UPDATE_LOCAL_DATA') : t('UPDATE_LOCAL_DATA')}
          onClick={() => onUpdateLocalData?.(row, !pending)}
          sx={{ py: 0.5, px: 1.5, minWidth: 0 }}
        />
      );
    }
  }
];
